/** @format */
import { SearchFacet } from '@toucan/common/services/search/constants';
import { Facet, SelectedFilters } from '@toucan/common/services/search/types';

import { toCamelCase } from '@toucan/client/global/axios';

import { PreTranslatedFilter } from '@toucan/client/features/search/components/model-search-results/types';

export function getFacetAllowList(
    selectedFilters: SelectedFilters,
    outOfStock: boolean
): string[] {
    // Allowlist already applied facets
    const facetAlwaysAllowList = [...Object.keys(selectedFilters ?? {})];

    if (!outOfStock) {
        facetAlwaysAllowList.push(
            ...[
                SearchFacet.productPrice,
                SearchFacet.productConditionStarRating,
                SearchFacet.productPriceModifier,
            ]
        );
    }

    return facetAlwaysAllowList;
}

export function getFacetsWithAtLeastTwoValues(
    facets: Facet[],
    facetAlwaysAllowList: string[]
): Facet[] {
    return facets.filter((facet) => {
        const id = toCamelCase(facet.field);

        if (facetAlwaysAllowList.includes(id)) {
            return true;
        }

        return facet.count >= 2;
    });
}

export function transformFacetsToFilters(
    facets: Facet[],
    translatedFacetTitles: Record<string, string>,
    openedFilter: Facet | null
): PreTranslatedFilter[] {
    return facets.map((facet): PreTranslatedFilter => {
        const id = toCamelCase<SearchFacet>(facet.field);
        const label = translatedFacetTitles?.[id] || id;

        const values =
            openedFilter?.field === facet.field
                ? openedFilter.values
                : facet.values;

        return {
            id,
            label,
            values,
        };
    });
}
